window.Products.Clothing.YogaLeggings = function () {
};

window.Products.Clothing.YogaLeggings.inherits(window.Products.Clothing.Clothing);

window.Products.Clothing.YogaLeggings.id = 46;
window.Products.Clothing.YogaLeggings.slug = 'yoga-leggings';
window.Products.Clothing.YogaLeggings.has_3d = true;
window.Products.Clothing.YogaLeggings.dpi = 150;

window.Products.Clothing.YogaLeggings.prototype.set3dProperties = function (modelViewer) {
    this.updateThreeTexture(modelViewer);
    
    modelViewer.object.position.y = 0.1;
};

window.Products.Clothing.YogaLeggings.prototype.updateThreeTexture = function (modelViewer) {
    modelViewer.object.children[0].material.map = modelViewer.texture;
    modelViewer.object.children[1].material.map = modelViewer.texture;
    modelViewer.object.children[0].material.bumpScale = 0.0005;
    modelViewer.object.children[1].material.bumpScale = 0.0005;
};

window.Products.Clothing.YogaLeggings.prototype.setThreeControls = function (controls) {
    controls.minDistance = 3.1;
    controls.maxDistance = 4;
};